import React from "react";
import { Segment, Message, TransitionablePortal } from "semantic-ui-react";

function ResponseMessage (props) {
    const { status, message } = props;
    return (
        <TransitionablePortal
            open={status !== ''}
            transition={{ animation: 'slide up', duration: 700 }}
        >
            <Segment
                basic
                style={{
                right: '0%',
                position: 'fixed',
                bottom: '0%',
                zIndex: 1000
                }}
            >
                {status === "success" && <Message 
                    success
                    content={message}
                />}
                {status === "error" && <Message 
                    error
                    content={message}
                />}
            </Segment>
        </TransitionablePortal>
    );
}

export default ResponseMessage;